import { render } from "./Passengers.vue?vue&type=template&id=7f69157e"
import script from "./Passengers.vue?vue&type=script&lang=js"
export * from "./Passengers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__